<div class="filters">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchValue" (ngModelChange)="queueFilter($event)">
    <button *ngIf="searchValue" mat-icon-button matSuffix aria-label="Clear search" (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>

<div class="scroll-container" (scroll)="onScroll($event)">
  <table mat-table [dataSource]="items" class="table">
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>Created</th>
      <td mat-cell *matCellDef="let item">{{item.createdAt | date:'medium'}}</td>
    </ng-container>

    <ng-container matColumnDef="vendor">
      <th mat-header-cell *matHeaderCellDef>Vendor</th>
      <td mat-cell *matCellDef="let item">{{item.vendor}}</td>
    </ng-container>

    <ng-container matColumnDef="product">
      <th mat-header-cell *matHeaderCellDef>Product</th>
      <td mat-cell *matCellDef="let item">{{item.product}}</td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let item">{{item.action}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let item">{{item.status}}</td>
    </ng-container>

    <ng-container matColumnDef="payload">
      <th mat-header-cell *matHeaderCellDef>Payload</th>
      <td mat-cell *matCellDef="let item">{{getPayload(item)}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let item">
        <button mat-stroked-button color="primary" (click)="openDetails(item)">View Details</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['createdAt','vendor','product','action','status','payload','actions']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['createdAt','vendor','product','action','status','payload','actions']"></tr>
  </table>

  <div class="loading" *ngIf="loading">Loading...</div>
  <div class="empty" *ngIf="!loading && items.length === 0">There are no webhook events to show.</div>
</div>
